// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".product-scheduling-options[data-v-6131bd5b] {\n  display: flex;\n  justify-content: space-between;\n}\n", ""]);
// Exports
module.exports = exports;
